const typeCheck = value => {
  const valueType = typeof value
  switch (true) {
    case valueType === 'number':
      return 'number'
    case valueType === 'boolean':
      return 'bool'
    case valueType === 'function':
      return 'func'
    case Array.isArray(value):
      return 'list'
    case value && valueType === 'object':
      return 'object'

    default:
      return 'string'
  }
}

export default typeCheck
